import { useMutation } from "@tanstack/react-query";

import { testCustomNotification } from "../../services/custom_notifications";

import { INotificationQualifiedUsers } from "../../types/custom_notifications";

interface IPayload {
    data: number;
    setNotificationQualificationResult: React.Dispatch<React.SetStateAction<INotificationQualifiedUsers[]>>;
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setApiError: React.Dispatch<React.SetStateAction<string | null>>;
};

interface IResponse {
    statusCode: number;
    message: string;
    data: INotificationQualifiedUsers[];
    error?: string;
}

const useTestCustomNotification = () => {
    const mutationFn = async (payload: IPayload) => {
        return await testCustomNotification(payload.data);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
            variables.setApiError(null);
        },
        onSuccess: (response: IResponse, variables: IPayload) => {
            variables.setNotificationQualificationResult(response.data);
            variables.setIsProcessing(false);
            variables.setApiError(null);
        },
        onError: (error: any, variables: IPayload) => {
            variables.setNotificationQualificationResult([]);
            variables.setIsProcessing(false);
            variables.setApiError(error.response?.data?.message); // actual type of error: AxiosError
            // toast.error(error.response?.data?.message);
        },
        onSettled: (response: IResponse | undefined, error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
            // variables.setApiError(null);
        }
    });
};
export default useTestCustomNotification;